import { render, staticRenderFns } from "./SnackbarTemplate.vue?vue&type=template&id=49de8a5f&scoped=true&"
import script from "./SnackbarTemplate.ts?vue&type=script&lang=ts&"
export * from "./SnackbarTemplate.ts?vue&type=script&lang=ts&"
import style0 from "./SnackbarTemplate.scss?vue&type=style&index=0&id=49de8a5f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49de8a5f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VIcon,VSnackbar})
